export const GET_HEALTH_SERVICES = 'GET_HEALTH_SERVICES';
export const GET_HEALTH_STATUS = 'GET_HEALTH_STATUS';
